module.exports = __webpack_public_path__ + "static/white-header-bg.feaf64a9.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/white-header-bg.png
// module id = 1058
// module chunks = 2